import React, { useState } from 'react';
import { Box, VStack, Spinner, Text, Alert, AlertIcon, AlertTitle, AlertDescription, HStack, Select, Button, Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';
import { useStrictAnalysisData } from './useStrictAnalysisData';
import CaseHeaderPanel from './CaseHeaderPanel';
import CarrierInfoPanel from './CarrierInfoPanel';
import MedicalNecessityPanel from './MedicalNecessityPanel';
import CodingAnalysisPanel from './CodingAnalysisPanel';
import DocumentManagerPanel from './DocumentManagerPanel';
import HeaderMenus from '../HeaderMenus';
import ModernChat from '../ModernChat';

const DefaultStrictAnalysis = ({ caseId }) => {
  const {
    initialLoading,
    error,
    caseData,
    carrierData,
    caseFiles,
    results,
    claimsData,
    claimType,
    setClaimType,
    pipelineVersion,
    setPipelineVersion,
    skipFetchRef,
    isNMA,
    isAdmin,
    refreshData
  } = useStrictAnalysisData(caseId);

  const [loadingMode, setLoadingMode] = useState(null);

  const runAnalysis = (mode) => {
    setLoadingMode(mode);
    setPipelineVersion(mode);
    skipFetchRef.current = true;
    // Actual API call logic would go here
  };

  if (initialLoading && !results) {
    return (
      <Box>
        <HeaderMenus />
        <VStack py={12} spacing={4}>
          <Spinner size="xl" color="blue.500" thickness="4px" />
          <Text>Checking for existing analysis...</Text>
        </VStack>
      </Box>
    );
  }

  return (
    <Box>
      <HeaderMenus />
      <Box p={8} maxWidth="1200px" margin="0 auto">
        
        <CaseHeaderPanel 
          caseData={caseData} 
          pipelineVersion={pipelineVersion} 
          isNMA={isNMA} 
          isAdmin={isAdmin} 
        >
          <HStack spacing={4}>
            <Select 
              value={claimType} 
              onChange={(e) => setClaimType(e.target.value)}
              width="150px"
              bg="white"
            >
              <option value="pro">Pro Claim</option>
              <option value="tech">Tech Claim</option>
            </Select>
            <Button 
              colorScheme="purple" 
              onClick={() => runAnalysis('advanced')} 
              isLoading={loadingMode === 'advanced'}
              loadingText="Running Mode 2..."
            >
              Generate & View Mode 2
            </Button>
          </HStack>
        </CaseHeaderPanel>

        {error && (
          <Alert status="error" mb={6} borderRadius="md">
            <AlertIcon />
            <Box>
              <AlertTitle>Analysis Failed</AlertTitle>
              <AlertDescription>{error}</AlertDescription>
            </Box>
          </Alert>
        )}

        <Tabs variant="enclosed" colorScheme="blue">
          <TabList>
            <Tab>Strict Analysis</Tab>
            <Tab>Dx Chat</Tab>
            <Tab>CPT Chat</Tab>
          </TabList>

          <TabPanels>
            <TabPanel px={0} py={4}>
              
              <CarrierInfoPanel data={carrierData} />
              
              {loadingMode && !results ? (
                <VStack py={12} spacing={4}>
                  <Spinner size="xl" color="blue.500" thickness="4px" />
                  <Text>Running strict rule evaluation and scoring...</Text>
                </VStack>
              ) : (
                <>
                  <MedicalNecessityPanel results={results} />
                  <CodingAnalysisPanel results={results} claimsData={claimsData} claimType={claimType} />
                </>
              )}
              
              <DocumentManagerPanel caseId={caseId} caseFiles={caseFiles} onUploadSuccess={refreshData} />

            </TabPanel>

            <TabPanel>
              <Box h="600px">
                <ModernChat 
                  caseId={caseId} 
                  contextType="icd10_context" 
                  height="600px"
                  additionalContext={results ? JSON.stringify(results, null, 2) : null}
                />
              </Box>
            </TabPanel>

            <TabPanel>
              <Box h="600px">
                <ModernChat 
                  caseId={caseId} 
                  contextType="cpt_ionm_context" 
                  height="600px"
                  additionalContext={results ? JSON.stringify(results, null, 2) : null}
                />
              </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>

      </Box>
    </Box>
  );
};

export default DefaultStrictAnalysis;
